export const DEFAULT_SUPER_CATEGORY = 'events';
export const DEFAULT_LOCATION = {
  latLng: {
    lat: -1.2920659,
    lng: 36.8219462,
  },
  address: 'Nairobi, Kenya',
  locationForURL: '-in-nairobi-kenya',
};
